<template>
  <div class="columns print-bg">
    <div class="column is-8 is-offset-2">
      <div class="card" @click="click" @mouseover="over" @mouseout="out">
        <div class="overlay" v-if="showOverlay" @click="showPlayer">
          <div v-if="!player.loading" class="icon"><i class="fal fa-play-circle"></i></div>
          <div v-if="player.loading"><span class="loader"></span></div>
        </div>
        <header class="card-header">
          <div class="card-header-title">
            <figure v-if="favicon" class="image is-16x16"><img v-if="favicon" :src="favicon" :alt="site"></figure>
            <span v-if="!favicon" class="icon"><i v-if="!favicon" class="fal fa-link"></i></span>
            &nbsp;
            {{site}}
          </div>
        </header>
        <div v-if="image && !player.loaded" class="card-image" ref="image">
          <figure class="image is-4by3">
            <img :src="image" :alt="title">
          </figure>
        </div>
        <div v-show="player.loaded" class="card-image">
          <div :id="playerID"></div>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title">{{title}}</p>
            </div>
          </div>
          <div class="content">{{description}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import youtube from '@/libs/youtube'
import videoType from '@/libs/video-type'

export default {
  props: ['attachment'],
  data: function () {
    return {
      showOverlay: false,
      overlayTimer: null,
      player: { loading: false, loaded: false }
    }
  },
  computed: {
    metadata: function () {
      return this.attachment.metadata || {}
    },
    image: function () {
      if (this.metadata.ogImage) {
        return this.metadata.ogImage
      }

      if (this.metadata.screenshot) {
        return this.metadata.screenshot
      }

      return ''
    },
    description: function () {
      if (this.metadata.ogDescr) {
        return this.metadata.ogDescr
      }

      return this.metadata.descr
    },
    title: function () {
      if (this.metadata.ogTitle) {
        return this.metadata.ogTitle
      }

      return this.metadata.title
    },
    site: function () {
      if (this.metadata.ogName) {
        return this.metadata.ogName
      }

      const parts = this.metadata.url.match(/\/\/([^/]+)/)
      if (parts.length > 1) {
        return parts[1]
      }

      return this.metadata.url
    },
    favicon: function () {
      return this.metadata.favicon
    },
    videoType: function () {
      return videoType.getType(this.attachment.url)
    },
    playerID: function () {
      return `video-player-${this._uid}`
    },
    playerSize: function () {
      const boundingRect = this.$refs.image.getBoundingClientRect()
      let width = Math.floor(boundingRect.width)
      let height = Math.floor(boundingRect.height)

      if (width / 4 * 3 < height) {
        height = Math.floor(width / 4 * 3)
      } else {
        width = Math.floor(height / 3 * 4)
      }

      return { width, height }
    }
  },
  methods: {
    click: function () {
      if (this.videoType) {
        this.showPlayer()
      } else {
        this.openURL()
      }
    },
    openURL: function () {
      window.open(this.attachment.url, '_blank')
    },
    showPlayer: function () {
      if (this.player.loading || this.player.loaded) {
        return
      }

      this.showOverlay = true
      this.player.loading = true

      if (this.overlayTimer) {
        clearTimeout(this.overlayTimer)
      }

      switch (this.videoType) {
        case 'youtube':
          return this.embedYoutube()
      }

      this.openURL()
    },
    embedYoutube: function () {
      const options = {
        id: this.playerID,
        url: this.attachment.url,
        width: this.playerSize.width,
        height: this.playerSize.height,
        webRoot: this.$webRoot
      }

      youtube.init(options).then(() => {
        this.showOverlay = false
        this.player.loaded = true
      }, () => {
        this.openURL()
      })
    },
    over: function () {
      if (this.player.loading || this.player.loaded) {
        return
      }

      this.showOverlay = true

      if (this.overlayTimer) {
        clearTimeout(this.overlayTimer)
      }
    },
    out: function () {
      if (this.player.loading || this.player.loaded) {
        return
      }

      if (this.overlayTimer) {
        clearTimeout(this.overlayTimer)
      }

      this.overlayTimer = setTimeout(() => { this.showOverlay = false }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
  .columns {
    padding: 0.5rem;
  }

  .card {
    cursor: pointer;
  }

  .title {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.5rem;
  }

  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: black;
    color: white;
    opacity: 0.5;
    font-size: 5rem;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
